<app-authentication-forgotpassword (resetPasswordClicked)="onResetPassword($event)" (goBackClicked)="onGoBack()"
  (goToVerificationCodeClicked)="onGoToVerificationCode()" [email]="email$ | async">
</app-authentication-forgotpassword>